import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { btn, btnHoverStyle } from "./buttonStyles";

const RoundNewButton = ({ createNew }) => {
  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "12px" }}>
      <style>{btnHoverStyle}</style>
      <button
        className="btn-modern"
        onClick={createNew}
        style={{
          ...btn.base,
          ...btn.success,
          width: "40px",
          height: "40px",
          padding: 0,
          borderRadius: "50%",
          fontSize: "1rem",
        }}
      >
        <FontAwesomeIcon icon={faAdd} />
      </button>
    </div>
  );
};

export default RoundNewButton;
